import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_52f7r3s9un: FaireBrandEntity = {
  token: "b_52f7r3s9un",
  type: "brand",
  name: "Vitamize inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/d448ee02df1d92b77d1cac75c6a1f5fa5ae48157b3ebf676fef9dbae6b65e05c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d448ee02df1d92b77d1cac75c6a1f5fa5ae48157b3ebf676fef9dbae6b65e05c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d448ee02df1d92b77d1cac75c6a1f5fa5ae48157b3ebf676fef9dbae6b65e05c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d448ee02df1d92b77d1cac75c6a1f5fa5ae48157b3ebf676fef9dbae6b65e05c.jpeg",
  location: "brooklyn, NY, USA",
  minimumOrderDollars: 30,
  rating: 4.9,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "At our company, We believe that good health is essential to a happy life. That's why we've made it our mission to create high_quality health gummies that are both delicious and effective. We know that taking care of your health can be challenging, and that's why we've made our supplements easy and convenient to use. Whether you're looking to boost your immune system, improve your digestion, or support your oveall wellness, we have a gummy for you.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:28.789Z",
    importedBy: "entity-db-cli",
  },
};
